import React, { Component } from 'react';
import Particles from 'react-particles-js';
import Clarifai from 'clarifai';
import FaceRecognition from './Components/FaceRecognition/FaceRecognition';
import Navigation from './Components/Navigation/Navigation';
import Signin from './Components/Signin/Signin';
import Register from './Components/Register/Register';
import Logo from './Components/Logo/Logo'
import ImageLinkForm from './Components/ImageLinkForm/ImageLinkForm';
import Rank from './Components/Rank/Rank';
import './App.css';

const app = new Clarifai.App({
  apiKey: 'bfe84931b4414eb1b7671e7ed21d4c8e'
});

const particlesOptions = {
  particles: {
    number: {
      value: 80,
      density: {
        enable: true,
        value_area: 400,
      }
    }
  }
}

const initialState = {
  input: '',
      imageUrl: '',
      boxes: [],
      route: 'signin',
      isSignedIn: false,
      user: {
        id: '',
        name: '',
        email: '',
        entries: 0,
        joined: ''
      }
    }

class App extends Component {
  constructor(){
    super();
    this.state = initialState; 
  } 
      

   loadUser = (data) => {
    this.setState({user: {
      id: data.id,
      name: data.name,
      email: data.email,
      entries: data.entries,
      joined: data.joined
    }})
  }

calculateFaceLocation = (data) => {
  const clarifaiResponsedata = data;
  const regionsData = clarifaiResponsedata.outputs[0].data.regions;
  console.log(regionsData);
  const reducer = (accumulator, currentValue) => {
    const boundingBoxData = currentValue.region_info.bounding_box;
    console.log(accumulator);
    const image = document.getElementById('inputimage');
    const width = Number(image.width);
    const height = Number(image.height);
    const boxData =  {
      leftCol: boundingBoxData.left_col * width,
      topRow: boundingBoxData.top_row * height,
      rightCol: width - (boundingBoxData.right_col * width),
      bottomRow: height - (boundingBoxData.bottom_row * height),
    }
    accumulator.push(boxData);
    return accumulator;
  };
  const boxesData = regionsData.reduce(reducer, []);
  console.log(boxesData);
  return boxesData;
}


displayFaceBox = (boxes) => {
  this.setState({boxes: boxes});
}


  onInputChange = (event) => {
    this.setState({input: event.target.value});

  }

  onButtonSubmit = () => {
    this.setState({imageUrl: this.state.input});
    app.models
      .predict(
        Clarifai.FACE_DETECT_MODEL,
        this.state.input)
      .then(response => {
        if (response) {
          fetch('https://immense-sierra-27014.herokuapp.com/image', {
            method: 'put',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
              id: this.state.user.id
            })
          })
            .then(response => response.json())
            .then(count => {
              this.setState(Object.assign(this.state.user, { entries: count}))
            })
            .catch(console.log)

        }
        this.displayFaceBox(this.calculateFaceLocation(response))
      })
      .catch(err => console.log(err));
  }

  onRouteChange = (route) => {
    if (route === 'signout') {
      this.setState(initialState)
    } else if (route === 'home') {
      this.setState({isSignedIn: true})
    }
    this.setState({route: route});
  }

  render() {
   const { isSignedIn, imageUrl, route, boxes } = this.state;
    return (
      <div className="App">
      <Particles className='particles'
                params={particlesOptions}
                />
      <Navigation isSignedIn={isSignedIn} onRouteChange={this.onRouteChange}/>
      { route === 'home'
        ? <div>
          <Logo />
          <Rank
           name={this.state.user.name}
                entries={this.state.user.entries} />
          <ImageLinkForm
          onInputChange={this.onInputChange} 
          onButtonSubmit={this.onButtonSubmit}/>
      <FaceRecognition boxes={boxes} imageUrl={imageUrl}/>
      </div>
      : (
         route === 'signin' 
            ? <Signin loadUser={this.loadUser} onRouteChange={this.onRouteChange}/>
             : <Register loadUser={this.loadUser} onRouteChange={this.onRouteChange}/>
        )
       
    }
      </div>
      );
  }
}


export default App;
